import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { ConfiguracionApi } from './../interfaces/configuracion-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionApiService {

  constructor(
    private http: HttpClient
  ) { }

  public getAll(): Observable<ConfiguracionApi[]> {
    return this.http.get<ConfiguracionApi[]>(environment.urlApi + '/ConfiguracionAPI');
  }

  public post(object: ConfiguracionApi): Observable<object> {
    return this.http.post(environment.urlApi + '/ConfiguracionAPI', object);
  }

  public get(id: number): Observable<ConfiguracionApi> {
    return this.http.get<ConfiguracionApi>(environment.urlApi + '/ConfiguracionAPI/' + id);
  }

  public put(object: ConfiguracionApi): Observable<object> {
    return this.http.put(environment.urlApi + '/ConfiguracionAPI/' + object.id, object);
  }

  public delete(object: ConfiguracionApi): Observable<object> {
    return this.http.delete(environment.urlApi + '/ConfiguracionAPI/' + object.id);
  }

}